export const goToMailCommand = "uTb";
export const goToCalendarCommand = "vTb";
export const goToPeopleCommand = "wTb";
export const goToTasksCommand = "xTb";
export const goToToDoCommand = "yTb";
export const goToDevToolsCommand = "zTb";
export const goToEdgeTracingToolsCommand = "ATb";
export default {goToMailCommand,goToCalendarCommand,goToPeopleCommand,goToTasksCommand,goToToDoCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand};